import { createRequest } from '@shared/services';

export async function getOrder(params?: GetOrderPayload) {
    const searchParams = new URLSearchParams();
    const paramKeys = ['status', 'payment_type', 'ship_to', 'shipping_type'];

    if (params) {
        Object.entries(params).forEach(([key, value]) => {
            if (value === undefined || value === null) return;

            if (paramKeys.includes(key) && Array.isArray(value)) {
                value.forEach((item: string) => {
                    searchParams.append(key, item);
                });
            } else {
                searchParams.append(key, String(value));
            }
        });
    }

    const request = createRequest<GetOrderResponse>({
        url: `/order?${searchParams.toString()}`,
        method: 'GET',
        withAuthorization: true,
    });

    return request.execute();
}

export async function getOrderById(order_id: string) {
    const request = createRequest<OrderResponse>({
        url: `/order/${order_id}`,
        method: 'GET',
        withAuthorization: true,
    });

    return request.execute();
}

export async function postOrder(payload: PostCartCreateOrderPayload) {
    const request = createRequest<PostCartResponse>({
        url: '/order',
        method: 'POST',
        withAuthorization: true,
        data: payload,
    });

    return request.execute();
}

export async function postOrderRefund(order_id: string, payload: PostOrderRefundPayload) {
    const request = createRequest<OrderResponse>({
        url: `/order/${order_id}/refund`,
        method: 'POST',
        withAuthorization: true,
        data: payload,
    });

    return request.execute();
}

export async function postOrderRefundCalculate(
    order_id: string,
    payload: PostOrderRefundCalculatePayload
) {
    const request = createRequest<PostOrderRefundCalculateResponse>({
        url: `/order/${order_id}/refund/calculate`,
        method: 'POST',
        withAuthorization: true,
        data: payload,
    });

    return request.execute();
}

export async function postOrderExport(payload: PostOrderExportPayload) {
    const request = createRequest<BasicAPIResponse<Blob>>({
        url: `/order/export`,
        method: 'POST',
        responseType: 'blob',
        withAuthorization: true,
        data: payload,
    });

    return request.execute();
}

export async function postOrderRefundReview(
    order_id: string,
    payload: PostOrderRefundReviewPayload
) {
    const request = createRequest<OrderResponse>({
        url: `/order/${order_id}/refund/review`,
        method: 'POST',
        withAuthorization: true,
        data: payload,
    });

    return request.execute();
}

export async function putOrderCancel(order_id: string, reason: string) {
    const request = createRequest<OrderResponse>({
        url: `/order/${order_id}/cancel`,
        method: 'PUT',
        withAuthorization: true,
        data: {
            reason,
        },
    });

    return request.execute();
}

export async function putOrderComplete(order_id: string) {
    const request = createRequest<OrderResponse>({
        url: `/order/${order_id}/complete`,
        method: 'PUT',
        withAuthorization: true,
    });

    return request.execute();
}

export async function putOrderSection(
    order_id: string,
    section: string,
    payload: string | string[] | null
) {
    const request = createRequest<OrderResponse>({
        url: `/order/${order_id}/${section}`,
        method: 'PUT',
        withAuthorization: true,
        data: {
            [section]: payload,
        },
    });

    return request.execute();
}

export async function putOrderNotifyShipped(order_id: string, payload: ShippingInfo[]) {
    const request = createRequest<OrderResponse>({
        url: `/order/${order_id}/notify_shipped`,
        method: 'PUT',
        withAuthorization: true,
        data: payload,
    });

    return request.execute();
}

export async function putOrderNotifyStockUp(
    order_id: string,
    payload: { estimate_shipped_datetime: number }
) {
    const request = createRequest<OrderResponse>({
        url: `/order/${order_id}/notify_stock_up`,
        method: 'PUT',
        withAuthorization: true,
        data: payload,
    });

    return request.execute();
}

export async function putOrderInvoice(order_id: string, payload: InvoiceInfo) {
    const request = createRequest<OrderResponse>({
        url: `/order/${order_id}/invoice`,
        method: 'PUT',
        withAuthorization: true,
        data: payload,
    });

    return request.execute();
}

export async function putOrderBatchUpdateStatus(
    action: string,
    payload: PutOrderBatchUpdateStatusPayload
) {
    const request = createRequest<OrderResponse>({
        url: `/order/batch-update-status/${action}`,
        method: 'PUT',
        withAuthorization: true,
        data: payload,
    });

    return request.execute();
}

export async function putOrderBatchUpdateTags(
    type: 'add' | 'remove',
    payload: PutOrderBatchUpdateTagsPayload
) {
    const request = createRequest<OrderResponse>({
        url: `/order/batch-${type}/tags`,
        method: 'PUT',
        withAuthorization: true,
        data: payload,
    });

    return request.execute();
}

export async function putOrderBatchUpdateSellerRemark(
    field: string,
    payload: PutOrderBatchUpdateSellerRemarkPayload
) {
    const request = createRequest<OrderResponse>({
        url: `/order/batch-update/${field}`,
        method: 'PUT',
        withAuthorization: true,
        data: payload,
    });

    return request.execute();
}

export async function putOrderAddressBook(order_id: string, payload: OrderAddressBook) {
    const request = createRequest<OrderResponse>({
        url: `/order/${order_id}/address-book`,
        method: 'PUT',
        withAuthorization: true,
        data: payload,
    });

    return request.execute();
}
